import type * as React from 'react';
import { post } from '@Domain/Api';
import { navigateTo } from '@Infra/Navigation';
import ssoAuthenticationStarted, {
	type SsoAuthenticationStartedAction,
} from '@Application/Security/Sso/Actions/ssoAuthenticationStarted';
import ssoAuthenticationStartFailed, {
	type SsoAuthenticationStartFailedAction,
} from '@Application/Security/Sso/Actions/ssoAuthenticationStartFailed';
import type StartSsoAuthentication from '@Application/Security/Sso/Commands/StartSsoAuthentication';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = SsoAuthenticationStartedAction | SsoAuthenticationStartFailedAction;

type StartSsoAuthenticationResponse = {
	authorizationUrl: string;
};

// The only applicative function in this domain that produces a terminal side effect: it navigates the
// browser away, rather than returning data the UI renders. `UI/` never imports `Infra/` in value
// position — the navigation must be issued from here, the only layer allowed to speak to `Infra/`.
export default (command: StartSsoAuthentication) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const response = await post<StartSsoAuthenticationResponse>(
				`${parameters.api.host}/api/sso/authentications`,
				command.toJSON(),
				{ retryOnUnauthorized: false },
			);

			navigateTo(response.authorizationUrl);

			const action = ssoAuthenticationStarted({ authorizationUrl: response.authorizationUrl });
			dispatch(action);
			return action;
		} catch (error) {
			const action = ssoAuthenticationStartFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
